module.exports = __webpack_public_path__ + "media/images/version_merge/scroll_hint-fa42772cc9e9c2a2866f9c65444701a2.svg";